module.exports = __webpack_public_path__ + "src/shared-components/icons/close.026a72c53cf977a18b9c63edc664f02a.svg";